import React from 'react';
import {
    Box,
    Card,
    Skeleton,
    Stack,
    Typography,
    useTheme,
} from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import { formatCurrency } from '../../../../shared/utils';

const renderDate = (startDate: string, endDate: string) => {
    const start = new Date(startDate).toLocaleDateString('en-AU');
    const end = new Date(endDate).toLocaleDateString('en-AU');

    if (startDate === endDate) return start;

    return `${start} - ${end}`;
};

const AddOnChargesItem = ({
    reservation,
    isLoading,
}: {
    reservation: any;
    isLoading: boolean;
}) => {
    const theme = useTheme();

    return (
        <>
            {isLoading ? (
                <Skeleton variant='rounded' height={100} width='100%' />
            ) : (
                <Card
                    variant='outlined'
                    sx={{ borderRadius: 2, cursor: 'pointer' }}
                    onClick={() =>
                        window.open(
                            `/reservations/${reservation.module.name}/${reservation.id}`,
                            '_blank',
                            'noopener noreferrer',
                        )
                    }
                >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1.5,
                            p: 1,
                            alignItems: 'center',
                        }}
                    >
                        <img
                            src={reservation.module.photo}
                            style={{
                                aspectRatio: 1,
                                objectFit: 'cover',
                                borderRadius: theme.spacing(1),
                            }}
                            height={75}
                        />
                        <div>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                Reservation #{reservation.id} -{' '}
                                {reservation.module.name}
                            </Typography>
                            <Typography variant='body2'>
                                {renderDate(
                                    reservation.startDate,
                                    reservation.endDate,
                                )}
                            </Typography>
                        </div>
                        <Typography sx={{ fontWeight: 'bold', ml: 'auto' }}>
                            {formatCurrency(reservation.bookingTotal.total)}
                        </Typography>
                        <NavigateNext sx={{ mx: 1 }} />
                    </Box>
                </Card>
            )}
        </>
    );
};

const AddOnsCharges = ({
    addOns,
}: {
    addOns: { id: number; data: any; isLoading: boolean }[];
}) => {
    return (
        <Stack sx={{ gap: 1.5 }}>
            {addOns.map(({ id, data, isLoading }) => (
                <AddOnChargesItem
                    key={id}
                    reservation={data}
                    isLoading={isLoading}
                />
            ))}
            <Typography variant='body2'>
                * Charges for add-ons will be billed separately from this
                reservation
            </Typography>
        </Stack>
    );
};

export default AddOnsCharges;
